import * as React from "react";
import styled from "styled-components";

import { DefaultWidgetMap } from "@com.mgmtp.a12.formengine/formengine-core/lib/view";
import { ButtonProps } from "@com.mgmtp.a12.widgets/widgets-core/lib/button/main/button.api";

import {
	CREATE_ZAHLUNGSVORGANG_EPAYBL,
	GET_ZAHLUNGSVORGANGSTATUS_EPAYBL
} from "../../../utilities/variables/customEventNames";

export function isEpayblActionEvent(eventName: string | undefined): boolean {
	return eventName === CREATE_ZAHLUNGSVORGANG_EPAYBL || eventName === GET_ZAHLUNGSVORGANGSTATUS_EPAYBL;
}

export function EpayblActionButton(props: ButtonProps): React.ReactNode {
	return (
		<StyledEpayblActionWrapper>
			<StyledFlatButton {...props} />
		</StyledEpayblActionWrapper>
	);
}

const StyledEpayblActionWrapper = styled.span`
	display: inline-flex;
	flex-direction: column;
	align-items: flex-start;
	max-width: 100%;
	gap: 0.25rem;
	margin-bottom: 0.75rem;
`;

const StyledFlatButton = styled(DefaultWidgetMap.Button)`
	text-decoration: unset;
	&&&& {
		min-height: ${({ theme }) => theme.components.button.minHeight};
	}

	&:disabled,
	&:disabled:hover,
	&:disabled:focus {
		color: ${({ theme }) => theme.colors.text?.color ?? "#767676"};
		border-color: ${({ theme }) => theme.colors.interaction.disabled.color};
		background-color: ${({ theme }) => theme.colors.interaction.disabled.color};
		opacity: 0.75;
		cursor: not-allowed;
		pointer-events: none;
	}
`;
